<template>
    <div>
        <div class="form-input-group">
            <!-- <v-text-field
                id="hour-field"
                v-model="currentHour"
                type="time"
                min="00:00"
                max="23:59"
                outlined
                dense
                color="secondary lighten-1"
                @change="changeCurrentHour"
            ></v-text-field> -->
            <v-autocomplete
                :id="`hour-field-${title}-${date}`"
                v-model="currentHour"
                :items="hours"
                item-text="nome"
                return-object
                outlined
                dense
                item-color="secondary lighten-1"
                color="secondary lighten-1"
                append-icon=""
                @change="changeCurrentHour"
            >
                <template v-slot:prepend-inner>
                    <v-icon class="align-center" style="margin-top: 2px;" size="18">mdi-update</v-icon>
                </template>
            </v-autocomplete>
            <label :for="`hour-field-${title}-${date}`">
                <span style="font-style: normal;font-weight: normal;font-size: 14px;line-height: 18px;">
                    {{title}}
                </span>
                <br/>
                <strong class="secondary--text text--lighten-1" style="font-style: normal;font-weight: 500;font-size: 16px;line-height: 20px;">
                    {{date}}
                </strong>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "TimePickerField",
    props:{
        title: {
            type: String,
            default: "De"
        },
        date: {
            type: String,
            required: true,
        },
        hour:{
            type: String
        }
    },
    data: () => ({
        currentHour: undefined,
        hours: [
            "00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00",
            "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00","17:00",
            "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"
        ]
    }),
    created(){
        this.currentHour = this.hour;
    },
    watch:{
        hour(value){
            if(value){
                this.currentHour = this.hour;
            }
        }
    },
    computed:{

    },
    methods:{
        changeCurrentHour(value){
            this.$emit("changeHourDate", value);
        }
    }
}
</script>

<style scoped>
    /* .v-text-field--outlined /deep/ .v-input__control /deep/ .v-input__slot /deep/ .v-text-field__slot /deep/ input::-webkit-calendar-picker-indicator {
       display: none !important;
        -webkit-appearance: none !important;
    }  */

    label{
        order: -1;
        color: #ffffff;
    }
    
    .v-input:focus-within + label{
        color: var(--v-secondary-lighten1);
    }

    .form-input-group{
        display: flex; 
        flex-direction: column;
        max-width: 120px;
    }
</style>